<template>
   <billing-Layout>
  <slot>
        <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title">Contract Templates</h4>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex align-items-right justify-content-end">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link :to="{ name : 'Setting'}" class="btn btn-info btn-sm mr-2"><i class="fas fa-arrow-left"></i> Back</router-link>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
      
        <div class="container-fluid">
            <div class="row">
            <div class="col-12">

        <div class="card card-body">
            <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">TITLE</th>
                        <th scope="col">Alias</th>
                        <th scope="col"><button class="btn btn-success btn-sm mr-2 float-right" @click="MetAddNewcTemplate"><i class="fas fa-plus"></i> New Template</button></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="i in ContractTemLists" :key="i.id">
                        <td scope="row">{{i.title}}</td>
                        <td scope="row"><span v-if="i.alias !== null"> {{i.alias}}</span></td>
                        <td><button class="btn btn-secondary btn-sm float-right" @click="MetEditBtn(i.id,i.title,i.alias,i.description)"><i class="fas fa-edit"></i></button><button class="btn btn-danger btn-sm mr-2 float-right" @click="MetDeleteBtn(i.id)"><i class="fas fa-times"></i></button></td>
                    </tr>
                </tbody>
            </table>
            <Loader v-if="isLoading"></Loader>
            <div v-if="NoRecord ==true" class="text-center">no record</div>
            </div>
 
                </div>
              </div>
            </div>
        </div>
    <modal name="setting-ctemplate" height="auto" width="880px">
         <div class="card-header">New Template <button @click="closeModal" class="closeIcon"><span></span></button></div>
            <div class="card-body">

            <form @submit.prevent="MetSAddContractT">
            <div class="form-row">
              <div class="col-12">
                  <div class="form-row">
                    <div class="col-6">
                      <span id="" class="form-text ">Title:</span>
                     <input type="text" class="form-control" v-model="DataForm.title"  required>
                    </div>
                    <div class="col">
                      <span id="" class="form-text">Reference title: (no visible)</span>
                      <input type="text" class="form-control" v-model="DataForm.alias">
                    </div>
                  </div>
                </div>
                <div class="col-12">
                    <span id="" class="form-text"> Description:</span>
                    <vue-editor id="editor" v-model="DataForm.description" style="width:100%" />
                </div>
                <div class="col-12">
                    <span id="emailHelp" class="form-text text-muted">.</span>
                <button type="submit" class="btn btn-success float-right">{{DataForm.btnName}}</button>
                </div>
            </div>
            </form>
            </div>
        </modal>
    </slot>
    <notifications group="noti" position="top center"></notifications>
   </billing-Layout> 
</template>
<script>
import axios from 'axios'
import Loader from '@/components/shared/Loader'
import BillingLayout from '@/Layouts/Billing/BillingLayout'
import { VueEditor } from "vue2-editor";
export default {
  components:{
      BillingLayout,
      Loader,
      VueEditor
  },
  data() {
    return {
      isLoading : false,
      ContractTemLists :[],
      DataForm: {
        btnName : 'ADD',
        action : 'Add',
        id : null,
        title : null,
        alias : null,
        description : null
      },
      
      NoRecord : false
      
    }
  },
   mounted(){
    this.getCTemplates();
    },
     methods:{
       closeModal(){
        this.$modal.hide('setting-chart')
        },
        MetSAddContractT(){
          this.isLoading = true
        if(this.DataForm.action == 'Add'){
           window.billing.post('contracttemplate/add',{
                user_id : window.localuserdata,
                title : this.DataForm.title,
                alias : this.DataForm.alias,
                description : this.DataForm.description
           }).then((response) => {
               this.isLoading = false
                 console.log(response.data);
                 this.DataForm.title= null;
                 this.DataForm.alias = 0;
                 this.DataForm.description = 1;
                 this.NoRecord = false
                 this.$modal.hide('setting-ctemplate')
                 this.getCTemplates()
                  this.$notify({
                    group: 'noti',
                    title: 'Created',
                    type: 'success',
                    text: 'Created Template Successful'
                  });
                }).catch((error) => console.log(error,this.isLoading = false));
        }
        if(this.DataForm.action == 'Update'){
            this.isLoading = true
           window.billing.put('contracttemplate/edit/' + this.DataForm.id ,{
                user_id : window.localuserdata,
                id: this.DataForm.id,
                title: this.DataForm.title,
                alias: this.DataForm.alias,
                description: this.DataForm.description
           }).then((response) => {
                 this.getCTemplates()
                 this.DataForm.alias = null;
                 this.DataForm.title = null;
                 this.DataForm.description = null;
                 this.DataForm.btnName = 'ADD';
                 this.DataForm.action = 'Add';
                 this.NoRecord = null
                 this.isLoading = false
                 this.$modal.hide('setting-ctemplate')
                 this.$notify({
                    group: 'noti',
                    title: 'Updated',
                    type: 'success',
                    text: 'Updated Template Successful'
                  });
  
                }).catch((error) => console.log(error,this.isLoading = false));
        }
        },
        getCTemplates() {
          this.isLoading = true
            window.billing.get('contracttemplate/' + window.localuserdata)
                .then((response) => {
                  this.isLoading = false
                    this.ContractTemLists = response.data.result;
                    if(this.ContractTemLists.length ==0){
                      this.NoRecord = true
                    }
				            this.isLoading = false
                }).catch((error) => console.log(error));
        },
        MetEditBtn(id,title,alias,description){
            this.$modal.show('setting-ctemplate');
          this.DataForm = {
            btnName : 'UPDATE',
            action : 'Update',
            title : title,
            alias : alias,
            description : description,
            id : id
          }
        },
        MetDeleteBtn(id){
          this.isLoading = true
          this.$swal({
              title: "Delete this Template?",
              text: "Are you sure?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Yes, Delete it!"
        }).then((result) => {
            if (result.value) {
                window.billing.put('contracttemplate/' + id,{
                        user_id : window.localuserdata
                  }).then((response) => {
                        this.isLoading = false
                        this.getCTemplates()
                        this.$notify({
                          group: 'noti',
                          title: 'Deleted',
                          type: 'success',
                          text: 'Deleted Template Successful'
                        });
                  }).catch((error) => console.log(error,this.isLoading = false));
            }
        });
      this.isLoading = false   
     },
    MetAddNewcTemplate(){
     this.$modal.show('setting-ctemplate');
      this.DataForm = {
        btnName : 'ADD',
        action : 'Add'
      }
    }
  }
}
</script>
<style lang="scss">
  #editor {
    height: 300px;
  }
</style>


